import { InhouseTicketSystemType } from '@api';
import { DotNotationPaths } from '@common';
import { VenueDetailsOverviewEndKey } from 'src/i18next';

export type VenueInhouseTicketSystemTableRowType = {
  label: VenueDetailsOverviewEndKey<'VENUE_INHOUSE_TICKET_SYSTEM.ROWS'>;
  accessor: DotNotationPaths<InhouseTicketSystemType>;
};

export const venueInhouseTicketSystemRows: VenueInhouseTicketSystemTableRowType[] = [
  {
    label: 'TICKET_SYSTEM',
    accessor: 'ticketSystem',
  },
  {
    label: 'NOTES',
    accessor: 'notes',
  },
];

